import React, { memo } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { primaryGradient, secondaryGradient } from 'root/src/client/web/commonStyles'

const style = {
	button: {
		width: '100%',
		outline: 'none',
		borderRadius: 4,
		background: 'none',
		fontSize: 18,
		cursor: 'pointer',
		boxShadow: '0 5px 6px 0 rgba(0, 0, 0, 0.16)',
		border: 'none',
		height: '100%',
		fontWeight: 400,
		padding: [[5, 0, 5, 0]],
		backgroundImage: primaryGradient,
		'&:hover': {
			backgroundImage: secondaryGradient,
		},
	},
	subTitle: {
		fontSize: 12,
		fontWeight: 200,
	},
}

const Button = memo(({ classes, title, subtitle, onClick }) => (
	<button type="button" onClick={onClick} className={classes.button}>
		<div className={classes.title}>{title}</div>
		<div className={classes.subTitle}>{subtitle}</div>
	</button>
))

export default withStyles(style, { name: 'MuiButtonWithSubtitle' })(Button)
